






























import Vue from 'vue'
import { TitleWithIconElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TitleWithIconEl',

  props: {
    templateItemData: {
      type: Object as () => TitleWithIconElInterface,
      required: true
    }
  },

  computed: {
    separatorStyle (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'separator')) {
        return ''
      }
      return `height: 1px; background-color: ${this.$props.templateItemData.separator};`
    },
    cursorStyle (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'view') &&
        !Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'url')) {
        return ''
      }
      return 'cursor: pointer;'
    }
  },

  methods: {
    handleClick (): void {
      if (this.templateItemData.view !== undefined && this.templateItemData.uri !== undefined) {
        return this.getView(this.templateItemData.view, this.templateItemData.uri)
      }
    }
  }
})
